import { Ruleset } from "store/reducers/products/parameters/pl-parameters.types";
import { PropertyResponse } from "store/reducers/products/properties/pl-properties.types";
import { Validation } from "types/validation";

export enum TablesTypeEnum {
  INCLUDE = "INCLUDE",
  EXCLUDE = "EXCLUDE",
  ATTR_LOOKUP = "ATTR_LOOKUP",
  LOOKUP = "LOOKUP",
}

export const tablesTypes: TablesTypeEnum[] = [
  TablesTypeEnum.INCLUDE,
  TablesTypeEnum.EXCLUDE,
  TablesTypeEnum.ATTR_LOOKUP,
  TablesTypeEnum.LOOKUP,
];

export interface RuleTable {
  id: string;
  productLineId: string;
  rulesetIds: string[];
  tableType: TablesTypeEnum;
  lookUpFieldIndex: number;
  propertyIds: string[];
  rows: Row[];
  comments?: string;
  sources?: string;
  dbSchemaVersion: number;
  ownerTool?: string;
}

export interface RuleTableResponse {
  id: string;
  compareId: string;
  productLineId: string;
  rulesets: Ruleset[];
  tableType: string;
  lookUpFieldIndex: number;
  properties: PropertyResponse[];
  rows: Row[];
  comments?: string;
  sources?: string;
  dbSchemaVersion: number;
  ownerTool?: string;
  validations: Validation[];
}

export interface Row {
  id?: string;
  cells: Cell[];
}

export interface Cell {
  value: string[];
  propertyId: string;
}

export interface RuleTableResponsePage {
  total: number;
  items: number;
  page: number;
  ruleTables: RuleTableResponse[];
}

export interface RuleTablePage {
  total: number;
  items: number;
  page: number;
  ruleTables: RuleTable[];
}

export interface TablesQueryParams {
  items?: number;
  page?: number;
  tableTypes?: TablesTypeEnum[];
  rulesetIds?: string[];
  propertyIds?: string[];
  ownerTools?: string[];
}
